/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BlendedRateIssuerMatchType {
  HIOS_SPECIFIC = 'HIOS_SPECIFIC',
  PARENT_ISSUER = 'PARENT_ISSUER',
}
